import React from 'react';
import { ShieldCheck, Github, ExternalLink, Code2 } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="w-full border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 mt-auto text-xs text-slate-500 dark:text-slate-400 py-6 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Left: Branding & Disclaimer */}
        <div className="flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left">
          <div className="flex items-center gap-1.5 font-semibold text-slate-800 dark:text-slate-200">
            <ShieldCheck className="w-4 h-4 text-indigo-500" />
            Terms of Service & Privacy Policy Tracker
          </div>
          <span className="hidden sm:inline text-slate-300 dark:text-slate-700">•</span>
          <span className="text-slate-500 dark:text-slate-400">
            AI-powered structured diff & legal change intelligence
          </span>
        </div>

        {/* Right: Technical Notes & Links */}
        <div className="flex items-center gap-4 text-xs font-medium">
          <span className="flex items-center gap-1">
            <Code2 className="w-3.5 h-3.5 text-slate-400" />
            React 19 + TypeScript + Vite
          </span>
          <span className="text-slate-300 dark:text-slate-700">•</span>
          <span className="text-slate-400">
            Firebase Hosting
          </span>
        </div>
      </div>
    </footer>
  );
};
